import { MDBCol, MDBContainer, MDBRow } from "mdb-react-ui-kit";
import { getContactsInfo } from "@/utils/mockData/contactsMocks";
import { convertDeltaToHtmlConverter } from "@/utils/common/delta";
import { IContactData } from "@/models/contact";
import styles from "../../styles/contacts/Contacts.module.scss";
import ContactCard from "./ContactCard";

const ContactInfo = ({
    contactsData,
}: {
    contactsData: IContactData | undefined;
}) => {
    const contactsInfo = getContactsInfo(contactsData || {});

    return (
        <MDBContainer fluid className={styles.infoContainer}>
            <MDBCol>
                <h1 className={styles.infoTitle}>Contact us</h1>
                {contactsData?.contactUs?.subtitle ? (
                    <div
                        className={styles.infoDescription}
                        dangerouslySetInnerHTML={{
                            __html: convertDeltaToHtmlConverter(
                                contactsData?.contactUs?.subtitle
                            ),
                        }}
                    />
                ) : (
                    <div className={styles.infoDescription} />
                )}
            </MDBCol>
            <MDBRow className="justify-content-center">
                {contactsInfo?.map(contact => (
                    <ContactCard key={contact?.id} contactInfo={contact} />
                ))}
            </MDBRow>
        </MDBContainer>
    );
};

export default ContactInfo;
